import script from "./PulseLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./PulseLoader.vue?vue&type=script&lang=ts&setup=true"

import "./PulseLoader.vue?vue&type=style&index=0&id=049d67f1&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049d67f1"]])

export default __exports__